module.exports = __webpack_public_path__ + "static/media/jay.f231438a.jpg";